import React from "react";

const ButtonLoading = () => {
  return (
    <div>
      <div
        className={`h-6 w-6 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent`}
      ></div>
    </div>
  );
};

export default ButtonLoading;
